import React from "react";
import CustomButton from "../common/CustomButton";
import { useNavigate } from "react-router-dom";

const BookWithConfidence = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full px-4 md:px-12 lg:px-20 pt-10 md:pt-16 mb-20">
      {/* Heading */}
      <div className="text-center">
        <h3 className="text-black font-bold text-2xl md:text-3xl">
          Book With Confidence
        </h3>
        <p className="text-[15px] md:text-lg text-[#242424] mt-2">
          Get the most out of your free time wihtout any of the hassle.
        </p>

        <div className="w-[80px] h-[3px] bg-[#1FADC6] mx-auto mt-3"></div>
      </div>

      {/* Cards Wrapper */}
      <div
        className="
          flex flex-col
          md:flex-row
          justify-center
          items-center
          md:items-start
          gap-10
          md:gap-16
          mt-10
        "
      >
        {/* CARD 1 */}
        <div className="flex flex-col items-center text-center max-w-[260px]">
          <div className="mb-4">
            {/* icon */}
            <svg
              width="70"
              height="70"
              viewBox="0 0 69 69"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M58.2272 6.27226L42.2023 1.21185C39.6591 0.408734 37.0077 0 34.3406 0C31.6734 0 29.0221 0.408734 26.4789 1.21185L10.454 6.27226C7.10551 7.32971 4.8291 10.4358 4.8291 13.9473V41.7672C4.8291 46.8819 7.25977 51.6923 11.3774 54.7263L27.0765 66.294C29.181 67.8447 31.7265 68.6813 34.3406 68.6813C36.9546 68.6813 39.5001 67.8447 41.6047 66.294L57.3037 54.7263C61.4214 51.6923 63.8521 46.8819 63.8521 41.7672V13.9473C63.8521 10.4358 61.5756 7.32971 58.2272 6.27226ZM46.6715 30.5465L33.3921 43.826C31.8204 45.3976 29.2724 45.3976 27.7009 43.826L22.0096 38.1349C20.438 36.5632 20.438 34.0152 22.0096 32.4437C23.5812 30.8721 26.1293 30.8721 27.7008 32.4437L30.5463 35.2893L40.9803 24.8554C42.5519 23.2837 45.0999 23.2837 46.6714 24.8554C48.2432 26.4269 48.2432 28.9749 46.6715 30.5465Z"
                fill="black"
              />
            </svg>
          </div>

          <h4 className="font-semibold text-[18px] md:text-[20px]">
            Less scrolling. More doing.
          </h4>
          <p className="text-[15px] text-[#242424] mt-2 leading-relaxed">
            Fun things to do, all in one place.
          </p>
        </div>

        {/* Divider */}
        <div className="hidden md:block w-px h-[150px] bg-black" />

        {/* CARD 2 */}
        <div className="flex flex-col items-center text-center max-w-[260px]">
          <div className="mb-4">
            <svg
              width="59"
              height="64"
              viewBox="0 0 59 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.25 21.3408H55.25M3.25 21.3408V49.9415C3.25 53.5818 3.25 55.4011 3.95847 56.7915C4.58162 58.0145 5.57528 59.0099 6.79835 59.633C8.1874 60.3408 10.0067 60.3408 13.64 60.3408H44.8601C48.4933 60.3408 50.31 60.3408 51.6991 59.633C52.922 59.0099 53.9191 58.0145 54.5421 56.7915C55.25 55.4024 55.25 53.5857 55.25 49.9525V21.3408M3.25 21.3408V18.7415C3.25 15.1011 3.25 13.2796 3.95847 11.8892C4.58162 10.6661 5.57528 9.67244 6.79835 9.04929C8.18877 8.34082 10.0103 8.34082 13.6507 8.34082H16.25M55.25 21.3408V18.7308C55.25 15.0975 55.25 13.2782 54.5421 11.8892C53.9191 10.6661 52.922 9.67244 51.6991 9.04929C50.3087 8.34082 48.491 8.34082 44.8506 8.34082H42.25M16.25 8.34082H42.25M16.25 8.34082V1.84082M42.25 8.34082V1.84082M39 34.3408L26 47.3408L19.5 40.8408"
                stroke="black"
                strokeWidth="6.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h4 className="font-semibold text-[18px] md:text-[20px]">
            Built around real schedules
          </h4>
          <p className="text-[15px] text-[#242424] mt-2 leading-relaxed">
            Fixed times, custom bookings, or on-demand
          </p>
        </div>

        {/* Divider */}
        <div className="hidden md:block w-px h-[150px] bg-black" />

        {/* CARD 3 */}
        <div className="flex flex-col items-center text-center max-w-[260px]">
          <div className="mb-4">
            <svg
              width="60"
              height="60"
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Full Circle */}
              <circle
                cx="32"
                cy="32"
                r="24"
                fill="none"
                stroke="black"
                strokeWidth="5"
              />

              {/* Lightning Bolt */}
              <path
                d="M34 10
         L22 32
         H30
         L26 52
         L42 28
         H34
         Z"
                fill="black"
              />
            </svg>
          </div>

          <h4 className="font-semibold text-[18px] md:text-[20px]">
            No Friction
          </h4>
          <p className="text-[15px] text-[#242424] mt-2 leading-relaxed">
            Book clearly, show up confidently
          </p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mt-6 w-full">
        <CustomButton
          className="w-full sm:w-auto px-6 py-3 text-[15px] bg-[#0B1E2D]"
          onClick={() => {
            navigate("/experiences");
          }}
        >
          Explore Experiences
        </CustomButton>

        <CustomButton
          className="w-full sm:w-auto px-6 py-3 text-[15px]"
          onClick={() => {
            navigate("/signup");
          }}
        >
          Become a host
        </CustomButton>
      </div>
    </div>
  );
};

export default BookWithConfidence;
